// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import { VersionableFragmentDoc } from '../../../../components/ReadyPlanVersionHeader.generated';
export type UsePublishProductOffering_ProductOfferingFragment = { __typename?: 'ProductOffering', id: string, name: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, canPublish: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } } | null | undefined, effectiveStatus: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus }, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } };

export const UsePublishProductOffering_ProductOfferingFragmentDoc = gql`
    fragment UsePublishProductOffering_ProductOffering on ProductOffering {
  id
  name
  aggregateDraft {
    canPublish {
      ...PotentialOperationDetails
    }
    ...Versionable
  }
  effectiveStatus {
    code
  }
  aggregateLatest {
    id
    displayVersion
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${VersionableFragmentDoc}`;